import "./OurAdvisors.module.css";
import Header from "@/reusable_sections/Header";
import YourGuidingTeam from "./sections/YourGuidingTeam";
import CommonQuestions from "./sections/CommonQuestions";
import JoinTheFamily from "./sections/JoinTheFamily";
import Footer from "@/reusable_sections/Footer";
export default function OurAdvisorsPage() {
  return <div>
      <Header />
      <YourGuidingTeam />
      <CommonQuestions />
      <JoinTheFamily />
      <Footer />
    </div>;
}